// DS6.1.2 (!) You might want to use MenuList.tsx
//             that accepts an array of items and renders:
//             ListCard.tsx + ListItem.tsx[] composition
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './ListCard.scss';
const ListCard = (_param)=>{
    var { className, children, innerRef } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "innerRef"
    ]);
    const menusMatchTheme = useFlag('menus_match_theme');
    const content = /*#__PURE__*/ React.createElement("div", _object_spread({
        className: c(s['content'], className),
        ref: innerRef
    }, props), children);
    return menusMatchTheme ? content : /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT,
        tag: "div"
    }, content);
};
ListCard.displayName = 'ListCard';
export default ListCard;
